(() => {
  if (navigator.deviceMemory && navigator.deviceMemory < 4) {
    return;
  }

  /* x-eslint-disable */
  window.swinger.observer.initialize('.swinger-snowfall', (canvas) => {
    // Initial Setup
    const ctx = canvas.getContext('2d');

    canvas.width = innerWidth;
    canvas.height = innerHeight;

    window.addEventListener('resize', () => {
      canvas.width = innerWidth;
      canvas.height = innerHeight;
    });

    // Variables
    const attributes = {
      particleCount: 400, // Change amount of snowflakes
      particleSize: 3, // Max size of a snowflake
      fallingSpeed: 1, // Intensity of the snowfall horizontal
      colors: ['#ccc', '#eee', '#fff', '#ddd'], // Array of usable colors
    };

    // Utility Functions
    function randomIntFromRange(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    }

    function randomColor(colors) {
      return colors[Math.floor(Math.random() * colors.length)];
    }

    // Objects
    function Particle(x, y, radius, color, radians) {
      this.x = x * canvas.width;
      this.y = y * canvas.height;
      this.radius = radius;
      this.color = color;
      this.radians = radians;
      this.velocity = 0.005;

      this.update = () => {
        // Move these points over time
        this.radians += this.velocity;
        this.x = x * canvas.width + Math.cos(this.radians) * Math.ceil(canvas.width / 5);
        this.y = y * canvas.height + Math.tan(this.radians) * 600;

        this.draw();
      };

      this.draw = () => {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);
        ctx.fillStyle = this.color;
        ctx.fill();

        ctx.closePath();
      };
    }

    // Implementation
    let particles;

    function init() {
      particles = [];

      for (let i = 0; i < attributes.particleCount; i += 1) {
        particles.push(
          new Particle(
            Math.random(),
            Math.random(),
            randomIntFromRange(0.5, attributes.particleSize),
            randomColor(attributes.colors),
            Math.random() * 80,
          ),
        );
      }
    }

    // Animation Loop
    function animate() {
      requestAnimationFrame(animate);
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach((particle) => {
        particle.update();
      });
    }

    init();
    animate();
  }, false);
})();
